<template>
  <div>
    <div :class="isMobile ? 'footer_col_box' : 'footer_box'">
      <img
        class="logo"
        loading="lazy"
        v-lazy="require('../assets/top_logo.png')"
      />
      <div :class="isMobile ? 'col mt80' : 'flex'" class="ml-4">
        <div class="item_box">
          <div class="title">公司信息</div>
          <div class="line"></div>
          <div class="line1"></div>
          <div class="f_item_tx">苏州思源科安信息技术有限公司</div>
          <div class="f_item_tx">
            SUZHOU SYKEAN INFORMATION TECHNOLOGY CO.,LTD
          </div>
          <div class="f_item_tx">
            苏州：江苏省苏州市张家港保税区新兴产业育成中心A栋
          </div>
          <div class="f_item_tx">
            西安：陕西省西安市碑林区含光北路35号新兴际华大厦
          </div>
          <div class="f_item_tx">西安：陕西省西安市经开区凤城六路151号</div>
          <div class="f_item_tx">
            深圳：广东省深圳市宝安区宝源华丰总部经济大厦C座
          </div>
        </div>
        <div class="item_box" :class="isMobile ? 'mt80' : ''">
          <div class="title">联系我们</div>
          <div class="line"></div>
          <div class="line1"></div>
          <div class="f_item_tx1">网址： www.sykean.com</div>
          <div class="f_item_tx1">
            全国咨询热线：<a href="tel:15801031606">15801031606</a>
          </div>
          <div class="f_item_tx1">邮箱：sykean@sykean.com</div>
          <div class="flex">
            <img
              class="qrcode"
              loading="lazy"
              :class="isMobile ? 'mQrcode' : ''"
              v-lazy="require('../assets/qzh_qrcode.png')"
            />
            <img
              class="qrcode ml-2"
              :class="isMobile ? 'mQrcode ml160' : ''"
              loading="lazy"
              v-lazy="require('../assets/dy_qrcode.png')"
            />
          </div>
        </div>
        <div class="item_box" :class="isMobile ? 'mt80' : ''">
          <div class="title">公司主营业务</div>
          <div class="line"></div>
          <div class="line1"></div>
          <div class="flex">
            <div class="flex-1">
              <div class="f_item_tx">虹膜门禁设备</div>
              <div class="f_item_tx">虹膜识别技术</div>
              <div class="f_item_tx">虹膜人脸门禁机</div>
              <div class="f_item_tx">煤矿虹膜门禁</div>
              <div class="f_item_tx">公安门禁</div>
              <div class="f_item_tx">精准识别身份认证</div>
            </div>
            <div class="flex-1">
              <div class="f_item_tx">虹膜采集仪</div>
              <div class="f_item_tx">虹膜识别技术</div>
              <div class="f_item_tx">虹膜门禁考勤机</div>
              <div class="f_item_tx">司法社区矫正</div>
              <div class="f_item_tx">虹膜识别身份认证</div>
              <div class="f_item_tx">虹膜识别身份认证</div>
            </div>
            <div class="flex-1">
              <div class="f_item_tx">虹膜采集器</div>
              <div class="f_item_tx">门禁机</div>
              <div class="f_item_tx">矿山虹膜考勤</div>
              <div class="f_item_tx">监狱监所AB门</div>
              <div class="f_item_tx">虹膜+人脸身份认证</div>
              <div class="f_item_tx">虹膜智能考勤</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copy">
      <div class="container">
        <div class="row copy_t">
          <span class="copy_bt"
            >Copyright2022&nbsp;&nbsp;<a href="/" target="_blank">sykean.com</a
            >&nbsp;&nbsp;
            <a target="_blank" href="https://beian.miit.gov.cn/"
              >苏ICP备2022000706号-1</a
            >&nbsp;<span> | </span>&nbsp;
          </span>
          <img
            :class="isMobile ? 'img1' : 'img'"
            loading="lazy"
            v-lazy="require('../assets/copy.png')"
            alt=""
          />
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >苏ICP备2022000706号-1</a
          >
        </div>
      </div>
    </div>

    <a href="tel:15801031606" v-if="isMobile" class="phoneDiv"> </a>
  </div>
</template>

<script>
export default {
  name: "footerNav",
  data() {
    return {};
  },
  computed: {
    isMobile() {
      // 布尔值，指示当前设备是否被认为是移动设备
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      );
    },
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
  .logo {
    width: 264px;
    height: 80px;
  }

  .item_box {
    display: flex;
    flex-direction: column;
    flex: 1;
    .title {
      font-family: PingFang SC;
      font-size: 40px;
      font-weight: 500;
      line-height: 56px;
      text-align: left;
      color: #fff;
    }
    .line {
      width: 107px;
      height: 2px;
      background: #008fd7;
      margin-top: 10px;
    }
    .line1 {
      width: 100%;
      height: 1px;
      background: #293a49;
      margin-bottom: 20px;
    }
  }

  .f_item_tx {
    font-family: PingFang SC;
    font-size: 28px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    margin-top: 30px;
    color: #fff;
  }
  .f_item_tx:hover {
    color: #fff;
  }
  .f_item_tx1 {
    font-family: PingFang SC;
    font-size: 40px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    margin-top: 30px;
    color: #fff;
  }
  .qrcode {
    width: 108px;
    height: 138px;
    margin-top: 30px;
  }
  .mQrcode {
    // flex: 1;
    margin-top: 30px;
    // padding: 30px;
    // width: auto;
    // height: auto !important;
  }
  .flex {
    display: flex;
    width: 100%;
  }
  .flex-1 {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .ml-4 {
    margin-left: 40px;
  }
  .ml-2 {
    margin-left: 20px;
  }
  .footer_col_box {
    width: 100%;
    background: #050f19;
    display: flex;
    flex-direction: column;
    padding: 70px 200px 70px 150px;
    .item_box {
      line-height: 40px;
      .f_item_tx {
        line-height: 40px;
      }
      .f_item_tx1 {
        line-height: 40px;
      }
      .qrcode {
        width: 432px;
        height: 552px;
        margin-top: 60px;
      }
    }
  }

  .copy {
    width: 100%;
    background: #050f19;
    border-top: 1px solid #979797;
    color: #fff;
    .copy_bottom {
      padding-bottom: 1.21428571rem;
    }
    .copy_t {
      padding-bottom: 0.78571428rem;
      display: flex;
      justify-content: center;
      margin-top: 0.92857142rem;
      span {
        text-align: center;
        color: #999999;
        font-size: 1rem;
        line-height: 1;
      }
      a {
        color: #999999;
        font-size: 1rem;
        line-height: 1;
      }
      .img {
        width: 16px;
        height: 16px;
        margin-right: 0.39285714rem;
      }
      .img1 {
        width: 26px;
        height: 26px;
        margin-right: 0.39285714rem;
      }
    }
  }
  .mb180 {
    margin-bottom: 180px;
  }
  .phoneDiv {
    width: 176px;
    height: 392px;
    background-image: url("../assets/right_bg.png");
    background-size: 176px 392px;
    position: fixed;
    bottom: 12%;
    right: 20px;
    border-radius: 10px;
    overflow: hidden;
  }
}

@media screen and (min-width: 1200px) {
  .logo {
    width: 132px;
    height: 40px;
  }

  .item_box {
    display: flex;
    flex-direction: column;
    flex: 1;
    .title {
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      text-align: left;
      color: #fff;
    }
    .line {
      width: 107px;
      height: 2px;
      background: #008fd7;
      margin-top: 10px;
    }
    .line1 {
      width: 100%;
      height: 1px;
      background: #293a49;
      margin-bottom: 20px;
    }
  }

  .f_item_tx {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    margin-top: 30px;
    color: #9f9f9f;
  }
  .f_item_tx:hover {
    color: #fff;
  }
  .f_item_tx1 {
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    margin-top: 30px;
    color: #fff;
  }
  .qrcode {
    width: 108px;
    height: 138px;
    margin-top: 30px;
  }
  .flex {
    display: flex;
    width: 100%;
  }
  .flex-1 {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .ml-4 {
    margin-left: 40px;
  }
  .ml-2 {
    margin-left: 20px;
  }
  .footer_col_box {
    width: 100%;
    background: #050f19;
    display: flex;
    flex-direction: column;
    padding: 70px 200px 70px 150px;
    .item_box {
      line-height: 40px;
      .f_item_tx {
        line-height: 40px;
      }
      .f_item_tx1 {
        line-height: 40px;
      }
      .qrcode {
        width: 324px;
        height: 414px;
        margin-top: 60px;
      }
    }
  }

  .copy {
    width: 100%;
    background: #050f19;
    border-top: 1px solid #979797;
    color: #fff;
    .copy_bottom {
      padding-bottom: 1.21428571rem;
    }
    .copy_t {
      padding-bottom: 0.78571428rem;
      display: flex;
      justify-content: center;
      margin-top: 0.92857142rem;
      span {
        text-align: center;
        color: #999999;
        font-size: 1rem;
        line-height: 1;
      }
      a {
        color: #999999;
        font-size: 1rem;
        line-height: 1;
      }
      .img {
        width: 16px;
        height: 16px;
        margin-right: 0.39285714rem;
      }
      .img1 {
        width: 26px;
        height: 26px;
        margin-right: 0.39285714rem;
      }
    }
  }
  .mb180 {
    margin-bottom: 180px;
  }
  .phoneDiv {
    width: 100%;
    background: #f5f5ff;
    position: fixed;
    bottom: 0;
    padding: 20px;
    .pBtn {
      width: 60%;
      height: 150px;
      line-height: 150px;
      margin: 0 20%;
      font-size: 70px;
      text-align: center;
      color: white;
      border: 1px solid rgb(9, 135, 251);
      background-color: rgb(9, 135, 251);
      border-radius: 80px;
    }
  }
}
.footer_box {
  width: 100%;
  height: 529px;
  background: #050f19;
  display: flex;
  padding: 70px 200px 70px 150px;
}
</style>
